import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AdminSidebar from '../components/admin/AdminSidebar';
import AdminHeader from '../components/admin/AdminHeader';
import { AdminHeaderProvider } from '../contexts/AdminHeaderContext';
import { ToastProvider } from '../contexts/ToastContext';
import ToastContainer from '../components/common/ToastContainer';
import { useAuthStore } from '../stores/authStore';
import { getShop } from '../api/shop.api';
import { ensureShopTypeTabDefault } from '../stores/serviceTabsStore';
import { connectSocket, disconnectSocket } from '../services/socket.service';
import styles from '../assets/scss/layout/AdminLayout.module.scss';
import sidebarStyles from '../assets/scss/layout/AdminSidebar.module.scss';
import headerStyles from '../assets/scss/layout/AdminHeader.module.scss';

export default function AdminLayout() {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [shopName, setShopName] = useState('');
    const user = useAuthStore((state) => state.user);
    const location = useLocation();
    const hideHeader = /^\/admin\/bills\/\d+$/.test(location.pathname)
        || location.pathname.startsWith('/admin/services/create')
        || /^\/admin\/services\/\d+/.test(location.pathname)
        || location.pathname.startsWith('/admin/employees/')
        || location.pathname === '/admin/bills/create';

    const hideSidebar = location.pathname === '/admin/bills/create';

    useEffect(() => {
        if (!user?.shopId) return;
        getShop(user.shopId)
            .then(({ data }) => {
                setShopName(data?.nameShop || '');
                // Áp cấu hình danh mục mặc định theo ngành (1 lần) — dùng luôn shopType vừa fetch
                ensureShopTypeTabDefault(data?.shopType ?? null);
            })
            .catch(() => {});
    }, [user?.shopId]);

    // Connect socket khi layout mount, disconnect khi unmount
    useEffect(() => {
        connectSocket();
        return () => disconnectSocket();
    }, []);

    const toggleSidebar = () => {
        // Mobile: toggle drawer
        if (window.innerWidth < 1024) {
            setMobileOpen(!mobileOpen);
        } else {
            setSidebarCollapsed(!sidebarCollapsed);
        }
    };

    return (
        <ToastProvider>
        <AdminHeaderProvider>
        <div className={`${styles.adminLayoutV2}${sidebarCollapsed ? ` ${styles.adminLayoutV2Collapsed}` : ''}${hideSidebar ? ` ${styles.adminLayoutV2NoSidebar}` : ''}`}>
            {/* Mobile overlay */}
            {mobileOpen && !hideSidebar && (
                <div
                    className={`${sidebarStyles.adminSidebarOverlay} ${sidebarStyles.adminSidebarOverlayVisible}`}
                    onClick={() => setMobileOpen(false)}
                />
            )}

            {!hideSidebar && (
                <AdminSidebar
                    collapsed={sidebarCollapsed}
                    mobileOpen={mobileOpen}
                    onClose={() => setMobileOpen(false)}
                    shopName={shopName}
                />
            )}
            {!hideHeader && <AdminHeader onToggleSidebar={toggleSidebar} shopName={shopName} />}

            <div className={`${styles.adminLayoutV2Main}${sidebarCollapsed && !hideSidebar ? ` ${headerStyles.sidebarCollapsed}` : ''}${hideHeader ? ` ${styles.adminLayoutV2NoHeader}` : ''}`}>
                <div className={styles.adminLayoutV2Content}>
                    <Outlet />
                </div>
            </div>
            <ToastContainer />
        </div>
        </AdminHeaderProvider>
        </ToastProvider>
    );
}
